import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AppSettings } from 'app/app.settings';
import { CapUtilService } from '@mommy/services/caputil.service';

// 註：此元件不可使用 @PageTrack decorator。page-track.decorator 會 import AppModule，
// 而本元件被 util.service 匯入，會形成 util.service -> 本元件 -> AppModule -> util.service
// 的循環相依，導致 SSR bundle 啟動時 "Cannot access 'UserState' before initialization"。
// 頁面追蹤改為直接呼叫 caputil.logEvent。
@Component({
  selector: 'app-download-app-modal',
  templateUrl: './download-app-modal.page.html',
  styleUrls: ['./download-app-modal.page.scss'],
})
export class DownloadAppModalPage implements OnInit {
  // 依瀏覽裝置平台決定顯示哪個商店徽章；桌面版兩個都顯示
  show_ios = false;
  show_android = false;

  constructor(
    public modalController: ModalController,
    private platform: Platform,
    private caputil: CapUtilService
  ) {}

  ngOnInit() {
    try {
      this.caputil.logEvent('page_view', {
        page_title: 'DownloadAppModalPage',
      });
    } catch (error) {
      console.log('logEvent error', error);
    }

    const is_ios = this.platform.is('ios');
    const is_android = this.platform.is('android');

    if (is_ios) {
      this.show_ios = true;
    } else if (is_android) {
      this.show_android = true;
    } else {
      // 桌面瀏覽器：無法判斷手機平台，兩個商店連結都提供
      this.show_ios = true;
      this.show_android = true;
    }
  }

  download(store: 'ios' | 'android') {
    try {
      this.caputil.logEvent('download_app_click', { store });
    } catch (error) {
      console.log('logEvent error', error);
    }

    const url =
      store === 'ios' ? AppSettings.URL_APP_STORE : AppSettings.URL_GOOGLE_PLAY;
    window.open(url, '_blank');
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
